import React, { useEffect, useRef, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import Toolbar from '@material-ui/core/Toolbar';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import useStyles from './global-filter.styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

  // Define a default UI for filtering
  export default ({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
    dropdownData
  }) => {
    const classes = useStyles();
    const ref = useRef(null);
    const [value, setValue] = useState(globalFilter);
    const [isSearchShow, showSearch] = useState(false);

    const onChange = useAsyncDebounce(value => {
      setGlobalFilter(value || undefined)
    }, 200);

   /*ref.current.contains(event.target) => we ask if our ref has received a click on it.
    ref.current.contains() is the method. If the condition is true, we set the state showSearch === false.
     This will close the search text area. */
    
    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            showSearch(false);
        }
      };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
          document.removeEventListener("click", handleClickOutside, true);
        };
      });

    return (
        <span>
            <div className={classes.root}>
                <Toolbar 
                    classes={{
                        root: classes.toolbarRoot
                    }}
                >
                    <div className={classes.search} ref={ref}>
                        <div className={classes.searchIcon} onClick={(e) => { showSearch(!isSearchShow) }}>
                            <SearchIcon />
                        </div>
                        <Autocomplete 
                          classes={{ listbox: classes.listbox, popper: isSearchShow ? classes.showPopup : classes.hidePopup }}
                          id="dropdown-elem"
                          clearOnBlur={false}
                          options={dropdownData}
                          onChange={(event, value) => {
                            setValue(value);
                            onChange(value);
              
                          }}
                          renderInput={(params) => (
                            <InputBase 
                                placeholder="Search by place"
                                classes={{
                                  root: classes.inputRoot,
                                  input: isSearchShow ? classes.inputShow : classes.inputHide,
                              }}
                              ref={params.InputProps.ref}
                              inputProps={params.inputProps}
                              onChange={e => {
                                setValue(e.target.value);
                                onChange(e.target.value);
                              }}
                              autoFocus
                            />
                          )}
                        />
                    </div>
                </Toolbar>
            </div>
        </span>
    )
  }